import { WorkOrderStatus, WorkOrderTaskType } from '@xbcb/work-order-types';
import type { WorkOrderTask } from '@xbcb/api-gateway-client';
import { taskIsInProgress } from '@xbcb/work-order-utils/dist/findMostRecentInProgressTask';

const permissibleInquireWorkOrderStates = [
  WorkOrderStatus.IN_PROGRESS,
  WorkOrderStatus.COMPLETED,
];

export const showInquireWorkOrderKebabMenuItemFunc = ({
  status,
  taskType,
  taskId,
  workOrderTasks,
}: {
  status?: WorkOrderStatus;
  taskType?: WorkOrderTaskType;
  taskId?: string;
  workOrderTasks?: WorkOrderTask[];
}) => {
  const task = taskId
    ? workOrderTasks?.find((task: WorkOrderTask) => task.id === taskId)
    : workOrderTasks?.find(
        (task: WorkOrderTask) =>
          task.definition?.workOrderTaskType === taskType,
      );
  const isException = Boolean(
    task?.isException ||
      workOrderTasks?.find(
        (task: WorkOrderTask) => task.definition?.isException,
      ),
  );

  if (status && permissibleInquireWorkOrderStates.includes(status)) {
    // not on task page
    if (
      !taskType &&
      !taskId &&
      (isException || status === WorkOrderStatus.IN_PROGRESS)
    ) {
      return true;
    }
    // on task page
    if (task && taskIsInProgress(task)) {
      return true;
    }
  }
  return false;
};
